import React, { Component } from 'react';

import './AthHairTypeBar.css';
class AthHairTypeBar extends Component {
  constructor(props) {
      super(props);
      this.state = {
        filledIn: false,
        score: props.score
      };
  }

  componentDidMount() {
    setTimeout(() => {
      let barInside = document.querySelector("." + this.props.category);
      if(barInside) {
        barInside.style.width = this.calculateScore().toString() + "%";
      }
    },2000);
  }

  calculateScore() {
    let score = this.props.score;
    let bounds = this.generateBounds(score);
    let userId = this.props.userId;
    let lastDig = parseInt(userId.toString().split('').pop(), 10);
    return (
      parseInt((lastDig / 10) * (bounds[1] - bounds[0]) + bounds[0], 10)
    );
  }

  generateBounds(score) {
    let arr = [];
    let boundA = 0;
    let boundB = 0;
    if (this.props.category === "condition") {
      if (score === 2 || score === 3) {
          boundA = 77;
          boundB = 99;
      } else if (score >= 4 && score <= 6) {
        boundA = 44;
        boundB = 66;
      } else {
        boundA = 22;
        boundB = 33;
      }
    } else if (this.props.category === "dandruff") {
       switch(score) {
        case 1:
          boundA = 75;
          boundB = 99;
          break;
        case 2:
          boundA = 50;
          boundB = 74;
          break;
        case 3:
          boundA = 25;
          boundB = 49;
          break;
        case 4:
          boundA = 1;
          boundB = 24;
        break;
        default:
          boundA = 1;
          boundB = 24;
      }
    } else {
      switch(score) {
      case 1:
          boundA = 1;
          boundB = 20;
          break;
        case 2:
          boundA = 21;
          boundB = 40;
          break;
        case 3:
          boundA = 41;
          boundB = 60;
          break;
        case 4:
          boundA = 61;
          boundB = 80;
          break;
        case 5:
          boundA = 81;
          boundB = 99;
        break;
        default:
          boundA = 81;
          boundB = 99;
      }
    }
    arr.push(boundA);
    arr.push(boundB);
    return arr;
  }


  render() {
    return (
      <div className="ath-hair-type-bar">
        <div className="ath-hair-type-bar__category">
          <h4>{ this.props.category }</h4>
          <div className="ath-hair-type-bar__bar-label-container">
            <div className="ath-hair-type-bar__label ath-hair-type-bar__label__left">
              { this.props.leftLabel }
            </div>
            <div className="ath-hair-type-bar__bar-container">
              <div className={"ath-hair-type-bar__bar-body " + this.props.category}>
              </div>
              <hr className="ath-hair-type-bar__bar-body-line ath-hair-type-bar__bar-body-line__one" />
              <hr className="ath-hair-type-bar__bar-body-line ath-hair-type-bar__bar-body-line__two" />
              <hr className="ath-hair-type-bar__bar-body-line ath-hair-type-bar__bar-body-line__three" />
            </div>
            <div className="ath-hair-type-bar__label ath-hair-type-bar__label__right">
              { this.props.rightLabel }
            </div>
            <div style={{ "left": `calc(65.5px + ${(this.calculateScore().toString() / 2)}%)`}} className="ath-hair-type-bar__percent-label">
              { this.calculateScore().toString() + "%" }
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default AthHairTypeBar;



// WEBPACK FOOTER //
// ./src/ath/components/profile/AthHairTypeBar.js